import * as React from 'react';
import styled from '@emotion/styled';
import { buildDlqIgnoreRuleCols } from './util';
import { Form } from './form';
import { Table } from './table';
import { Button } from '../../components';
const ShowStyles = styled.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .edit-form {
    overflow: auto;
    height: 60%;
  }
`;
export const Show = ({ state, form, actions, error }) => {
    var _a;
    const columns = React.useMemo(() => buildDlqIgnoreRuleCols(), []);
    return (React.createElement(ShowStyles, null,
        React.createElement(Table, Object.assign({ columns: columns, ignoreRules: state.ignoreRules, selectedId: (_a = state.selected) === null || _a === void 0 ? void 0 : _a.id }, actions)),
        React.createElement("div", { className: "edit-form" },
            React.createElement(Button, { onClick: () => actions.newRule() }, "New"),
            React.createElement(Form, Object.assign({ error: error, info: state.info, form: form, ignoreRule: state.selected }, actions)))));
};
//# sourceMappingURL=show.js.map